import { DenouncedGender } from "../Model/DenouncedGender";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { getCurrentUser } from "./session";
import { v4 as v4uuid } from "uuid";
export class DenouncedGenderService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(third_id, ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('denounced/gender/' + ndiligencia + '/third_id/' + third_id);
            if (!response.ok) {
                throw new Error(`Error al obtener al agresor`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener DenouncedId`);
        }
    }
    async findOneByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('denounced/gender/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener al agresor`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener DenouncedId`);
        }
    }
    async saveDenouncedGender(denounded) {
        if (denounded) {
            const response = await this.apiService.post('denounced/gender/', denounded);
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciado de Genero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener  Genero.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`denounced/genderThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async createDenouncedGender(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new DenouncedGender({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                denouncedThirId: thirdId,
                userId: getCurrentUser().id,
                criminalRecord: false,
                profesionId: null,
                employmentSituation: null,
                workplaceId: null,
                economicSituation: " ",
                familyResponsibilities: false,
                temperament: " ",
                healthStatus: null,
                addictions: " ",
                frequentPlaces: " ",
                vehicles: " "
            });
            const response = await this.apiService.post('denounced/gender', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async deleteDenouncedGender(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('denounced/gender/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciado de una diligencia genero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciado.`);
        }
    }
}
